/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface DataQueryExecutionAPI
 * @hideconstructor
 * @classdesc API class that is used to execute data queries.
 * @example content.getFeature('DataQueryExecution')
 */
define([], () => {
	class DataQueryExecutionAPI {

		/**
		 * @function DataQueryExecutionAPI#addRequestOptions
		 * @description Collects additional request parameters, which are passed to the query service when executing queries
		 * @private
		 *
		 * @param {Object[]} [requestOptions] request options
		 * @param {String} [requestOptions[].name] request option name
		 * @param {String} [requestOptions[].value] request option value
		 */
		addRequestOptions() {}

		/**
		 * @function DataQueryExecutionAPI#removeRequestOptions
		 * @description Removes request parameters, which are passed to the query service when executing queries
		 * @private
		 * @param {String[]} [requestOptions] request option names
		 */
		removeRequestOptions() {}

		/**
		 * @function DataQueryExecutionAPI#resetRequestOptions
		 * @description Resets request parameters, which are passed to the query service when executing queries
		 * @private
		 */
		resetRequestOptions() {}

		/**
		 * @function DataQueryExecutionAPI#executeQueries
		 * @description Executes queries
		 * @async
		 *
		 * @return {Promise<QueryResultsAPI>} Returns a promise that will be resolved with a {@link QueryResultsAPI} object.
		 */
		executeQueries() {}

		/**
		 * @function DataQueryExecutionAPI#getCurrentQueryResults
		 * @description Gets the current {@link QueryResultsAPI} object
		 * @public
		 * @return {QueryResultsAPI} the current {@link QueryResultsAPI} object
		 */
		getCurrentQueryResults() {}

		/**
		 * @function DataQueryExecutionAPI#registerQueryProvider
		 * @description Registers the query provider API to build queries
		 * @private
		 * @deprecated in favour of DataQueryExecutionAPI#registerQueryDefinitionProvider
		 *
		 * @param {QueryProvider} provider queryProvider API instantce
		 */
		registerQueryProvider() {}

		/**
		 * @function DataQueryExecutionAPI#registerQueryModifier
		 * @description Registers the query modifier API to modify queries
		 * @private
		 * @deprecated in favour of DataQueryExecutionAPI.registerQueryDefinitionModifier
		 *
		 * @param {QueryModifier} modifier queryModifier API instantce
		 */
		registerQueryModifier() {}

		/**
		 * @function DataQueryExecutionAPI#registerQueryProvider
		 * @description Registers the query provider API to build query definitions
		 * @private
		 *
		 * @param {QueryDefinitionProvider} provider queryProvider API instance
		 */
		registerQueryDefinitionProvider() {}

		/**
		 * @function DataQueryExecutionAPI#registerQueryModifier
		 * @description Registers the query modifier API to modify query definitions
		 * @private
		 *
		 * @param {QueryDefinitionModifier} modifier queryModifier API instance
		 */
		registerQueryDefinitionModifier() {}

		/**
		 * @function DataQueryExecutionAPI#registerQueryPostProcessor
		 * @description Registers the query post processor on query result
		 * @private
		 *
		 * @param {QueryPostProcessor} postProcessor any query post processor that implements 'process' API function.
		 */
		registerQueryPostProcessor() {}
	}

	return DataQueryExecutionAPI;
});
